module.exports = __webpack_public_path__ + "static/media/p10.28d1175d.jpg";